import { useEffect, useState } from "react";

const fmt = () =>
  new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/London" }).format(new Date());

export const UkClock = ({ className = "" }) => {
  const [time, setTime] = useState(fmt);
  useEffect(() => {
    const id = setInterval(() => setTime(fmt()), 20000);
    return () => clearInterval(id);
  }, []);
  return (
    <span className={className} data-testid="uk-clock">
      UK {time}
    </span>
  );
};
